export const enum FieldName {
  Birthday = 'birthday',
  homeClubNewsletter = 'homeClubNewsletter',
}
